import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Vue, Prop, Mixins } from "vue-property-decorator";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
import Loader from "@/components/widgets/loader.vue";
// SYSTEMONE
import BaseMixer from "../../BaseMixer";
import { GuidItemModel } from "@/store/models/shared/guidItem";
import employeeModule from "@/store/modules/employee.module";
import { VUE_APP_APP_EXTERNAL_INTEGRATION_HUB_URL } from "@/services/config";
import { AuthModule } from "@/store/modules/auth.module";
import * as signalR from "@microsoft/signalr";
import Swal from "sweetalert2";
let ExternalApiSyncComponent = /** @class */ (() => {
    var _a;
    let ExternalApiSyncComponent = class ExternalApiSyncComponent extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.isloading = false;
        }
        Sync(externalApiId) {
            this.isloading = true;
            this.externalApiSyncStatuses.find((x) => x.id == externalApiId).isSelected = true;
            employeeModule.SyncDetailsFromExternalApi(externalApiId).then((response) => {
                if (response) {
                    this.isloading = false;
                }
            });
        }
        HideModal() {
            this.$emit("integrationModal");
            this.$bvModal.hide("externalApiSync");
        }
        get externalApiSyncStatuses() {
            return employeeModule.ExternalApiStatuses;
        }
        async initializeSignalR() {
            var accessKey = "";
            if (AuthModule.isAuthenticated && AuthModule.accessToken) {
                accessKey = `${AuthModule.accessToken}`;
            }
            const options = {
                accessTokenFactory: () => accessKey,
            };
            const apiUrl2 = VUE_APP_APP_EXTERNAL_INTEGRATION_HUB_URL;
            this.connection = new signalR.HubConnectionBuilder()
                .withUrl(apiUrl2, options)
                .configureLogging(signalR.LogLevel.Information)
                .build();
            this.connection.on("SyncStatusUpdated", (type, status, count) => {
                let message = "";
                if (status === "success") {
                    if (count === 0) {
                        message = "No records synced";
                    }
                    else if (type.toLowerCase() == this.Constant.ExternalApiTypes.Shift().toLowerCase()) {
                        message = `${count} employees shifts synced successfully!`;
                    }
                    else if (type.toLowerCase() === this.Constant.ExternalApiTypes.ReportingTo().toLowerCase()) {
                        message = `${count} employees Reporting To synced successfully!`;
                    }
                    else if (type.toLowerCase() === this.Constant.ExternalApiTypes.Designations().toLowerCase()) {
                        message = `${count} employees Designations synced successfully!`;
                    }
                    employeeModule.GetExternalApiStatusDetails();
                    Swal.fire({
                        text: message,
                        icon: "success",
                        width: "500px",
                        padding: "20px",
                        showCancelButton: false,
                        confirmButtonColor: "#34C38F",
                        confirmButtonText: "Okay",
                        customClass: {
                            popup: "swal-wide",
                        },
                    }).then(() => { });
                }
                else if (status === "failed") {
                    employeeModule.GetExternalApiStatusDetails();
                    Swal.fire({
                        text: "Sync failed. Please try again.",
                        icon: "error",
                        width: "500px",
                        padding: "20px",
                        confirmButtonColor: "#f46a6a",
                        confirmButtonText: "Okay",
                        customClass: {
                            popup: "swal-wide",
                        },
                    }).then(() => { });
                }
                this.isloading = false;
            });
            await this.connection
                .start()
                .then(() => {
                console.log("SignalR connection established successfully.");
            })
                .catch((err) => {
                console.error("SignalR connection failed:", err);
            });
        }
        async created() {
            await this.initializeSignalR();
            employeeModule.GetExternalApiStatusDetails().then((response) => {
                if (response) {
                    Vue.nextTick(() => {
                        console.log("Inside next tick");
                        if (this.connection.state === signalR.HubConnectionState.Connected) {
                            console.log("Connection is started");
                        }
                        else {
                            console.log("Connection is not started");
                        }
                        this.connection.invoke("Join", "externalApiIntegration").catch((err) => {
                            console.error("Failed to join SignalR group:", err);
                        });
                    });
                    this.$bvModal.show("externalApiSync");
                }
            });
        }
        destroyed() {
            this.$bvModal.hide("externalApiSync");
            // Clean up SignalR connection
            if (this.connection) {
                this.connection.invoke("Leave", "externalApiIntegration").catch((err) => {
                    console.error("Failed to leave SignalR group:", err);
                });
                this.connection.stop().catch((err) => {
                    console.error("Failed to stop SignalR connection:", err);
                });
            }
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof GuidItemModel !== "undefined" && GuidItemModel) === "function" ? _a : Object)
    ], ExternalApiSyncComponent.prototype, "externalApiProvider", void 0);
    ExternalApiSyncComponent = __decorate([
        Component({
            name: "ExternalApiSyncComponent",
            components: {
                SectionLoader,
                Loader,
            },
        })
    ], ExternalApiSyncComponent);
    return ExternalApiSyncComponent;
})();
export default ExternalApiSyncComponent;
